import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: [],
  error: null,
  loading: false,
  shipment: null,
  exportStatus: { loading: false, error: null },
}

const shipmentSlice = createSlice({
  name: "shipment",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setShipment(state, action) {
      state.shipment = action.payload
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      }
    },
    resetState(state) {
      state.data = []
      state.error = null
      state.loading = false
      state.shipment = null
      state.exportStatus = { loading: false, error: null }
    },
  },
})

export const shipmentAction = shipmentSlice.actions

export default shipmentSlice
